export class SettingsWindowService {
  // @ngInject
  constructor(private $window: ng.IWindowService) {}

  public openSettingsWindow(): void {
    this.$window.open("#/settings/", "_blank", "height=768,width=1024,location=no,resizable=yes,scrollbars=yes");
  }

  public openPivotInSettingsWindow(stem: string): void {
    this.$window.open(`#/settings/${stem}`, "_blank", "height=768,width=1024,location=no,resizable=yes,scrollbars=yes");
  }
}
